/**
 * @generated SignedSource<<dde4ef51d86e9485dd93cbd96a3b7008>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespBrowseHeader_itemSearch$data = {
  readonly meta: {
    readonly header: string | null;
  } | null;
  readonly pageType: string | null;
  readonly " $fragmentType": "SbRespBrowseHeader_itemSearch";
};
export type SbRespBrowseHeader_itemSearch$key = {
  readonly " $data"?: SbRespBrowseHeader_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespBrowseHeader_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespBrowseHeader_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "df9a6382a85f3b62d385a5c88149c62b";

export default node;
